import React, { useEffect } from 'react';
import { Wrapper } from './styled';
import Pagination from 'Common/Components/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { selectPage, selectRowsPerPageList } from 'store/Filters/selectors';
import { setAgentsEntity, setPageAgentExecutions } from 'store/Agents/actions';
import { selectAgentExecutionsCount } from 'store/Agents/selectors';
import { AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';

const Paginator = () => {
  const dispatch = useDispatch();
  const page = useSelector((state) => selectPage('agentExecutions', state));
  const count = useSelector(selectAgentExecutionsCount);
  const rowsPerPage = useSelector((state) => selectRowsPerPageList('agentExecutions', state));

  const setPage = (page) => {
    dispatch(setPageAgentExecutions(page));
  };

  const onPrev = () => setPage(page - 1);

  const onNext = () => setPage(page + 1);

  useEffect(() => {
    dispatch(setAgentsEntity(AGENTS_EXECUTION_ENTITY));
  }, [dispatch]);

  return (
    <Wrapper>
        <Pagination offset={ page } limit={ rowsPerPage } total={ count } onPrev={ onPrev } onNext={ onNext } />
    </Wrapper>
  );
};
export default Paginator;
